import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FreeStartButton } from './FreeStartButton';

export const HomeCTA = ({ id, children = 'Start pay as you go', to, light = false, onClick }) => !to ? <FreeStartButton id={id} onNavigate={onClick} className={`hm-button${light ? ' hm-button-light' : ''}`}>{children}</FreeStartButton> : (
  <Link to={to} onClick={onClick} className={`hm-button${light ? ' hm-button-light' : ''}`} data-testid={id}>
    {children}<ArrowRight size={17} aria-hidden="true" />
  </Link>
);

export const SectionHeading = ({ number, label, title, accent, description, id, dark = false }) => (
  <div className={`hm-section-heading${dark ? ' hm-heading-dark' : ''}`}>
    <div><h2 className="hm-eyebrow" data-testid={`${id}-eyebrow`}><span>{number}</span>{label}</h2>
      <p className="hm-display-title" data-testid={`${id}-heading`}>{title}{accent && <em> {accent}</em>}</p></div>
    {description && <p className="hm-section-description" data-testid={`${id}-description`}>{description}</p>}
  </div>
);